import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import BackgroundImage from '../../assets/advantages.webp'
import { COLOR_WHITE, COLOR_GREEN, COLOR_PINK_LIGHT } from '../../lib/colors'
import UIAdvantages from '../../components/UI/UIAdvantages'
import { useNavigate } from 'react-router-dom'
import LayoutCol from '../../components/Layout/LayoutCol'
import IconCirclePlus from '../../components/Icon/IconCirclePlus'
import { COLOR_GREEN_GRADIENT } from '../../lib/colors'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    top: '0',
    width: '100%',
    height: '120vh',
    overflow: 'hidden',
    position: 'relative',
    '@media (max-width: 480px)': {
      height: '750px',
    },
  },
  backgroundImage: {
    objectFit: 'cover',
    width: '100%',
    objectPosition: '20% 0',
  },
  containerContent: {
    position: 'absolute',
    padding: '5% 15%',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    justifyContent: 'space-between',
    '@media (max-width: 480px)': {
      padding: '15% 15%',
      justifyContent: 'inherit',
    },
    '@media (max-width: 1024px)': {
      alignItems: 'flex-start',
    },
  },
  button: {
    padding: '15px 60px',
    margin: '20px 0px',
    border: '2.5px solid #FFFFFF',
    fontWeight: 700,
    color: COLOR_WHITE,
    fontSize: '48px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    '@media (max-width: 480px)': {
      fontSize: '20px',
      marginBottom: '20px',
    },
    '@media (max-width: 1024px)': {
      margin: '0 auto',
    },
  },
  advantagesContainer: {
    gap: '90px',
    width: '100vw',
    padding: '10% 10% 0 10%',
    display: 'Flex',
  },
  col: {
    flexDirection: 'column',
    gap: '10vh',
    height: '70vh',
    flexWrap: 'wrap',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '0 35%',
    margin: '5% 0 1%',
    fontWeight: 700,
    color: COLOR_WHITE,
    '@media (max-width: 1024px)': {
      padding: '0 15%',
    },
    '@media (max-width: 480px)': {
      padding: '0 7.5%',
      height: '5%',
    },
    fontSize: '25px',
  },
  leftTitle: {
    background: COLOR_GREEN_GRADIENT,
    padding: '0.5em 1.3em',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  rightTitle: {
    background: 'linear-gradient(270deg, #E26B76 0%, #E58072 100%)',
    padding: '0.5em 1.3em',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
})

const Offers = () => {
  const { t } = useTranslation('translation')
  let navigate = useNavigate()

  const handleLeftTitle = () => {
    navigate('../pro')
  }

  const handleRightTitle = () => {
    navigate('../particulier')
  }

  return (
    <>
      <div className={css(styles.container)}>
        <img
          src={BackgroundImage}
          className={css(styles.backgroundImage)}
          alt="background image"
          width="100%"
          height="100%"
        />
        <div className={css(styles.containerContent)}>
          {window.innerWidth <= 1024 ? (
            <>
              <UIAdvantages
                title={`+ ${t('pages.home.offers.title1')}`}
                description={
                  t('pages.home.offers.description1') +
                  t('pages.home.offers.description11')
                }
                fontSizeTitle="29px"
                backgroundColorTitle={COLOR_GREEN}
              />
              <UIAdvantages
                title={`+ ${t('pages.home.offers.title2')}`}
                description={
                  t('pages.home.offers.description2') +
                  t('pages.home.offers.description21')
                }
                fontSizeTitle="29px"
                backgroundColorTitle={COLOR_PINK_LIGHT}
              />
              <UIAdvantages
                title={`+ ${t('pages.home.offers.title3')}`}
                description={
                  t('pages.home.offers.description3') +
                  t('pages.home.offers.description31')
                }
                fontSizeTitle="29px"
                backgroundColorTitle={COLOR_PINK_LIGHT}
              />
              <Link to="/be-a-viewer" style={{ textDecoration: 'none' }}>
                <div className={css(styles.button)}>
                  {t('pages.home.offers.seeOffers')}
                </div>
              </Link>
            </>
          ) : (
            <>
              <div className={css(styles.advantagesContainer)}>
                <LayoutCol col={6}></LayoutCol>
                <LayoutCol col={6} dynamicStyle={styles.col}>
                  <UIAdvantages
                    title={`+ ${t('pages.home.offers.title1')}`}
                    description={t('pages.home.offers.description1')}
                    description2={t('pages.home.offers.description11')}
                    fontSizeTitle="4em"
                    backgroundColorTitle={
                      'linear-gradient(90.07deg, #ED9964 0.06%, #E05D79 99.94%)'
                    }
                  />
                  <UIAdvantages
                    title={`+ ${t('pages.home.offers.title2')}`}
                    description={t('pages.home.offers.description2')}
                    description2={t('pages.home.offers.description21')}
                    fontSizeTitle="4em"
                    backgroundColorTitle={
                      'linear-gradient(90deg, #99B069 0%, #87AF7A 100%)'
                    }
                  />
                  <UIAdvantages
                    title={`+ ${t('pages.home.offers.title3')}`}
                    description={t('pages.home.offers.description3')}
                    description2={t('pages.home.offers.description31')}
                    fontSizeTitle="4em"
                    backgroundColorTitle={
                      'linear-gradient(90.07deg, #ED9964 0.06%, #E05D79 99.94%)'
                    }
                  />
                </LayoutCol>
              </div>
              <div className={css(styles.titleContainer)}>
                <div
                  className={css(styles.leftTitle)}
                  onClick={handleLeftTitle}
                >
                  <span>{t('pages.home.howItWorks.professional')}</span>
                  <IconCirclePlus />
                </div>
                <div
                  className={css(styles.rightTitle)}
                  onClick={handleRightTitle}
                >
                  <span>{t('pages.home.howItWorks.individual')}</span>
                  <IconCirclePlus />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default Offers
